require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-pages-exhibitors-list.json") })
        }
      }, "path---en-pages-exhibitors-list");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-pages-exhibitors-list!./.cache/json/en-pages-exhibitors-list.json
// module id = 755
// module chunks = 231608221292675